import { DropDownFilter, DropDownFilterProps } from 'framework/list';
import { Dropdown } from 'framework/form';
import { COMPLIANCE_REGISTRY_DOCUMENT_TYPE_OPTIONS } from 'domain/shared/compliance';

const DocumentTypeFilter = ({ source, label, ...props }: Omit<DropDownFilterProps, 'children'>) => {
  return (
    <DropDownFilter {...props} source={source} label={label}>
      <Dropdown source={source} label={label} options={COMPLIANCE_REGISTRY_DOCUMENT_TYPE_OPTIONS} />
    </DropDownFilter>
  );
};

export default DocumentTypeFilter;
